import { render } from "./NewsPopup.vue?vue&type=template&id=404be859&scoped=true"
import script from "./NewsPopup.vue?vue&type=script&lang=js"
export * from "./NewsPopup.vue?vue&type=script&lang=js"

import "./NewsPopup.vue?vue&type=style&index=0&id=404be859&scoped=true&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404be859"]])

export default __exports__